export const REGULAR_FONT = 'Varela, sans-serif';
